var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.container),attrs:{"id":"previewContainer"}},[_c('p',{ref:"previewText",style:(_vm.text),attrs:{"id":"previewText"},domProps:{"innerHTML":_vm._s(_vm.previewText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }